import script from "./MonacoLazyComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonacoLazyComponent.vue?vue&type=script&setup=true&lang=ts"

import "./MonacoLazyComponent.vue?vue&type=style&index=0&id=76d815bf&lang=scss&scoped=true"
import "./MonacoLazyComponent.vue?vue&type=style&index=1&id=76d815bf&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d815bf"]])

export default __exports__